<template>
  <div class="debugInfo">
    <div class="deviceHeader">
      <div class="deviceHeaderLeft">
        <div class="closepage" @click="goList"></div>
        <div>{{ `${$t('datalogger.datalogger_debug')}` }}</div>
      </div>
    </div>
    <div class="deviceBody">
      <el-form class="grid">
        <el-form-item :label="$t('datalogger.datalogger_pn')" size="small">
          <div>{{ deviceInfo.pn }}</div>
        </el-form-item>
        <el-form-item :label="$t('datalogger.communication_address')" size="small">
          <el-input class="devaddrClass" type="number" v-model="datalogger.devaddr" auto-complete="off"  oninput="if(value<1)value=1;if(value>255)value=255"></el-input>
        </el-form-item>
        <el-form-item :label="$t('datalogger.Instruction')" size="small">
          <el-input :rows="4" v-model="devDebug.cmd" :placeholder="$t('datalogger.such_as')" type="textarea"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <div style="text-align:right;">
            <button type="button" class="btn btn-dark" @click="submitDebugDatalogger()">{{ $t('datalogger.send')}}</button>
          </div>
        </el-form-item>
        <el-form-item :label="$t('datalogger.return_content')" size="small">
          <div class="debug-return">
            <div class="return-tool">
              <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                data-clipboard-target="#link">
                <i class="ico ico-copy"></i>
                {{ $t('device.copy_val') }}
              </span>
              <span class="btn" @click="qingkong()">
                <i class="ico ico-clear"></i>
                {{ $t('device.clear_val') }}
              </span>
            </div>
            <el-input :rows="10" readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import clipboard from "@/assets/js/clipboard";
export default{
  components:{
    
  },
  data(){
    return{
      datalogger: {
        devaddr: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
    };
  },
  computed: {
    ...mapGetters({
      getIsShow: 'getIsShow',
      deviceInfo: 'getDeviceInfo',
      dataloggerDetail: 'getDataloggerDetail'
    }),
  },
  beforeDestroy(){
    // if (this.dataloggerDetail.dataloggerDetail==2) {
    //     this.$store.commit('saveIsShow', 2);
    //     this.$store.commit('saveDataloggerDetail', 1);
    //   }else{
    //     this.$store.commit('saveIsShow', 1);
    //     this.$store.commit('saveDataloggerDetail', 1);
    //   }
  },
  created () {
  },
  methods:{
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // 发送指令
    submitDebugDatalogger () {
      if (this.datalogger.devaddr == null) {
        this.$message.error(this.$t("datalogger.devaddrfail"));
      } else if (this.deviceInfo.status == "1") {
        this.$message.error(this.$t("datalogger.Debugfail"));
      } else {
        this.debugReturn = this.$t("datalogger.instruction_response");
        let param = {
          pn: this.deviceInfo.pn,
          devaddr: this.datalogger.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("datalogger.debug_suc"));
            this.debugReturn = res.dat.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 返回列表
    goList(){
      if (this.dataloggerDetail.dataloggerDetail==2) {
        this.$store.commit('saveIsShow', 2);
        this.$store.commit('saveDataloggerDetail', 1);
      }else{
        this.$store.commit('saveIsShow', 1);
        this.$store.commit('saveDataloggerDetail', 1);
      }
      
    },
  }
}
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");
.debugInfo{
  display: flex;
  flex: 1;
  flex-direction: column;
  .deviceHeader{
    display: flex;
    font-size: 20px;
    color: #ffffff;
    justify-content: space-between;
    align-items: center;
    background-color: #222d35;
    .deviceHeaderLeft{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      div:last-child{
        padding-left: 16px;
        font-weight: 700;
      }
      .closepage {
        display: inline-block;
        background-color: #23323D;
        width: 60px;
        height:56px;
        background-image: url('../../../../assets/img/general/arrow_left.png');
        background-size: 24px 24px;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
    }
  }
  .deviceBody{
    height: 100%;
    background-color: #222d35;
    margin-top: 10px;
    padding:20px 500px 20px 110px ;
    color: #fff;
    .devaddrClass{
      width: 200px;
    }
    /deep/.el-form-item__label{
      color: #fff;
      height: 100%;
    }
    /deep/.el-input__inner{
      border-color: rgba(204, 206, 221, 0.5);;
      background: #2b3842;
      color: #fff;
    }
    /deep/.el-textarea__inner {
      border-color: rgba(204, 206, 221, 0.5);;
      background: rgba(43, 56, 66, 1);
      color: #fff;
    }
    // 统一按钮
    .btn {
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;
    }

    .btn-dark {
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      border: none;
    }
    // 设备调试返回值
    .debug-return {
      border: 1px solid rgba(204, 206, 221, 0.5);
      border-radius: 4px;
      padding: 0 8px 5px;
      background: rgba(43, 56, 66, 1);

      /deep/.el-textarea__inner {
        border: none;
        background: rgba(43, 56, 66, 1);
        color: #fff;
      }
      /deep/ 

      .return-tool {
        border-bottom: 1px dashed rgba(204, 206, 221, 0.5);
        text-align: right;

        .btn:hover {
          color: @primaryTextColor;

          .ico-clear {
            background: url(../../../../assets/img/general/Icon_Debug_Delete_Dark.png);
          }

          .ico-copy {
            background: url(../../../../assets/img/general/Icon_Debug_Copy_Dark.png);
          }
        }

        .btn {
          padding: 0px;
          color: rgba(235, 235, 235, 1);
          font-size: 12px;
          cursor: pointer;
        }

        .ico-clear {
          background: url(../../../../assets/img/general/Icon_Debug_Delete.png);
        }

        .ico-copy {
          background: url(../../../../assets/img/general/Icon_Debug_Copy.png);
        }

        .ico {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>